<hard-modal
  [title]="'base.settings' | hardTranslate"
  [icon]="'icon-settings'"
  (closeModal)="close()"
  [isMoving]="true"
  [actions]="!loading && widgets && selectedItem && action"
>
  <div
    class="flex flex-1 flex-col overflow-hidden"
    *hardPermissions="gridViewPermission"
  >
    @if (loading) {
      <hard-loading />
    } @else {
      @if (widgets) {
        <hard-form-grid
          [form]="widgetTypeForm"
          [config]="{ params: { fields: [widgetTypeConfig] } }"
        ></hard-form-grid>

        @if (selectedItem) {
          <div class="flex flex-col flex-1 overflow-hidden mt-1.5 px-1.5">
            <mat-tab-group>
              <mat-tab [label]="'grid.tab.main' | hardTranslate">
                @if (!reloadLoading) {
                  <div
                    @showEnter
                    class="tab-content pt-1.5"
                  >
                    @if (
                      !selectedItem?.screenWidgetId && !selectedItem?.screenId
                    ) {
                      <div class="mb-[10px]">
                        <hard-form-grid
                          [form]="screenForm"
                          [config]="{ params: { fields: screenConfig.fields } }"
                        ></hard-form-grid>
                      </div>
                    }

                    <hard-form-grid
                      [form]="baseForm"
                      [config]="{ params: { fields: baseConfig.fields } }"
                    ></hard-form-grid>

                    <ng-container *ngTemplateOutlet="rolesTabs"></ng-container>

                    @if (
                      selectedItem?.key < widgets?.length && selectedItem?.id
                    ) {
                      <div
                        class="mt-1.5 mx-2 pb-5 flex"
                        *hardPermissions="gridEditPermission"
                      >
                        <hard-button
                          type="danger"
                          (click)="$event.stopPropagation(); confirmDelete()"
                        >
                          <span class="mr-1.5 icon-busket"></span>
                          <span>
                            {{ "grid.delete.widget" | hardTranslate }}
                          </span>
                        </hard-button>
                      </div>
                    }
                  </div>
                } @else {
                  <hard-loading />
                }
              </mat-tab>
              <mat-tab
                [label]="'grid.tab.settings' | hardTranslate"
                class="mat_tab-label"
              >
                @if (!reloadLoading) {
                  <div
                    @showEnter
                    class="tab-content pt-1.5"
                  >
                    <hard-form-grid
                      [form]="settingsForm"
                      [config]="{
                        params: { fields: settingsConfig.fields },
                      }"
                    ></hard-form-grid>
                  </div>
                } @else {
                  <hard-loading />
                }
              </mat-tab>
            </mat-tab-group>
          </div>
        }
      } @else {
        <hard-no-data />
      }
    }
  </div>
</hard-modal>

<ng-template #action>
  <hard-button
    (click)="close()"
    *hardPermissions="gridEditPermission"
  >
    <span class="icon-cancel mr-1.5"></span>
    {{ "cancel" | hardTranslate }}
  </hard-button>

  <hard-button
    type="success"
    (click)="save()"
    [disabled]="
      !selectedItem?.screenWidgetId &&
      !selectedItem?.screenId &&
      !screenForm.valid
    "
    *hardPermissions="gridEditPermission"
  >
    <span class="icon-save mr-1.5"></span>
    {{ "base.save" | hardTranslate }}
  </hard-button>
</ng-template>

<ng-template #rolesTabs>
  @if (paramsConfig.fields.length) {
    <div class="widget-settings-roles mt-[10px]">
      <mat-tab-group
        [selectedIndex]="rolesIndex"
        (selectedIndexChange)="rolesIndex = $event"
      >
        <mat-tab [label]="'dicTable.byDefault' | hardTranslate">
          <div class="mt-1.5">
            <hard-form-grid
              [form]="paramsForm"
              [config]="{
                params: {
                  fields: paramsConfig.fields,
                },
              }"
            ></hard-form-grid>
          </div>
        </mat-tab>
        @for (widgetSettingsByRole of widgetSettingsByRoles; track $index) {
          <mat-tab
            [label]="
              widgetSettingsByRole.paramsForm.get('roles')?.value
                ? (widgetSettingsByRole.paramsForm.get('roles')?.value
                  | roleNames
                  | truncate: 15)
                : ('grid.setting.selectRole' | hardTranslate)
            "
          >
            <div class="mt-1.5">
              <hard-form-grid
                [form]="widgetSettingsByRole.paramsForm"
                [config]="{
                  params: {
                    fields: widgetSettingsByRole.config.fields,
                  },
                }"
              ></hard-form-grid>
            </div>
          </mat-tab>
        }

        <mat-tab
          [disabled]="true"
          [labelClass]="'!opacity-100'"
        >
          <ng-template mat-tab-label>
            @if (widgetSettingsByRoles.length && rolesIndex !== 0) {
              <hard-button
                class="mr-1.5"
                [classBtn]="'hard-btn--icon h-[35px] hard-btn--no-rounded color-red'"
                *hardPermissions="gridEditPermission"
                (click)="removeRoleSetting()"
                stop-propagation
              >
                <span class="icon-busket"></span>
              </hard-button>
            }

            <hard-button
              type="success"
              [classBtn]="'hard-btn--icon h-[35px] hard-btn--no-rounded'"
              (click)="addWidgetForRoles(paramsConfig)"
              stop-propagation
            >
              <span class="icon-plus"></span>
            </hard-button>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
</ng-template>
